import { IResponseModel } from "../../IResponseModel";
import { DiscordServerBasicInfo } from "../../shared/DiscordServerBasicInfo";

export class DiscordAuthResponse implements IResponseModel {
    server_list: DiscordServerBasicInfo[];
}